export default "__VITE_ASSET__1b6e7ecb__"